module.exports = __webpack_public_path__ + "img/Sales Analysis Color.aa8524b9.svg";